import { ENV } from '../env';

let json = JSON.stringify(require('./config.json'));

for (let key of Object.keys(ENV)) {
  const s = `\\\$\\\{${key}\\\}`;
  json = json.replace(new RegExp(s, 'gm'), ENV[key] || '');
}

export const config = JSON.parse(json);



// WEBPACK FOOTER //
// ./src/config/index.ts